module.exports = __webpack_public_path__ + "ff3b216c8a680f4c9d805d72999c9b3d.webp";